import React, { useContext, useRef } from "react";
import TextField from "@mui/material/TextField";
import DrawerItem from "components/Shared/MSidebar/DrawerItem";
import context from "components/Shared/MSidebar/utility/context";

const DrawerSearch = () => {
  const {openSidebar, open, searchText, onSearchChange, search} = useContext(context);
  const inputRef = useRef();
  return (
    <div onClick={() => {
      openSidebar(true);
      inputRef.current.focus();
    }}>
      <DrawerItem
        icon={"search"}
        iconOnClick={search}
      >
        <TextField
          {...{inputRef}}
          onChange={({target: {value}}) => onSearchChange(value)}
          onKeyDown={(e => {
            if(e.key === "Enter") {
              e.preventDefault();
              search();
            }
          })}
          value={searchText}
          autoFocus={open}
          className={"DrawerSearch-TextField"}
          placeholder={"Search"}
          fullWidth
        />
      </DrawerItem>
    </div>
  );
};

export default DrawerSearch;